"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constant = require("../constant");
var _ = require("./");
var getGeneralSubtitle = function getGeneralSubtitle(student) {
  if (!student) {
    return null;
  }
  if (!student.yearGraduation) {
    return '';
  }
  if (student.includeGPAOnResume) {
    return "".concat((0, _.isGraduated)(student.monthGraduation, student.yearGraduation), ": ").concat((0, _.getOptionValue)(_constant.month, parseInt(student.monthGraduation, 10)), " ").concat(student.yearGraduation, " | GPA: ").concat(student.gpa);
  }
  return "".concat((0, _.isGraduated)(student.monthGraduation, student.yearGraduation), ": ").concat((0, _.getOptionValue)(_constant.month, parseInt(student.monthGraduation, 10)), " ").concat(student.yearGraduation);
};
var _default = getGeneralSubtitle;
exports.default = _default;